import { GenericResponse } from 'types/GenericResponse';

export type UserPlatform = 'ADVOCATE' | 'EMPLOYER' | 'RECRUITER' | string;

export enum PlatForm {
  ADVOCATE = 'ADVOCATE',
  EMPLOYER = 'EMPLOYER',
  RECRUITER = 'RECRUITER',
}

export enum Tier {
  FREE = 'FREE',
  BASIC = 'BASIC',
  TEAM = 'TEAM',
  ENTERPRISE = 'ENTERPRISE',
}

export enum SessionOpenItem {
  STORY_SHARE = 'STORY_SHARE_OPEN_ITEM',
  AMPLIFIED_TEMPLATE_SHARE = 'AMPLIFIED_TEMPLATE_SHARE_OPEN_ITEM',
}

export enum SessionRedirectAfterLogin {
  LINKEDIN = 'SESSION_REDIRECT_AFTER_LOGIN_LINKEDIN',
}

export type LoginMeta = {
  email: string;
  password: string;
  fromSignup?: boolean;
  storyId?: string;
  companyId?: string;
  token?: string;
  logoutSSOUrl?: string;
  is_first?: boolean;
  refresh_token?: string;
};

export type LoginPayload = GenericResponse & {
  fromSignup?: boolean;
  data: GenericResponse['data'] & {
    isCompleteProfile?: boolean | string | null;
    forceFinishRegistration?: boolean | string | null;
    fromSSOLoginCallback?: boolean;
    companyId?: string | null;
    isFirst?: boolean | string | null;
    platform?: UserPlatform;
    /** Story share to open in My Shares after login. IPS-820 / IPS-855. */
    shareStoryId?: string | null;
  };
};
